<div
  id="nav-container"
  [style.height]="isShow ? '14vh' : '9vh'"
  style="width: 100%"
>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="collapse navbar-collapse" id="navbar-supported-content">
      <!-- <ul
        class="navbar-nav mx-auto"
        style="height: 100%; margin-left: 200px !important"
      >
        <li class="nav-item" *ngFor="let tab of tabs">
          <a
            class="nav-link"
            [routerLink]="tab.pathname"
            routerLinkActive="tab.name === active_tab"
            [ngClass]="{
              active: tab.name === active_tab,
              disabled: tab.name !== tabs[0].name
            }"
            >{{ tab.name }}</a
          >
        </li>
      </ul> -->
      <!-- <img
      src="./assets/cci_logo.png"
      style="height:36px;width:64px;cursor: pointer"
      (click)="handleRedirect()"
      alt=""
    /> -->
      <div></div>
      <div class="nav_header">PLANOPRO TOOL</div>

      <div class="profile">
        <img
          (click)="handleRedirect()"
          style="height: 15px; width: 15px; margin-right: 20px; cursor: pointer"
          src="./assets/home_icon.png"
        />
        <em
          class="bi bi-person"
          style="font-size: 1.3rem; cursor: pointer"
          [matMenuTriggerFor]="menu"
        ></em>
        <mat-menu #menu="matMenu" class="logout-menu">
          <button
            style="
              font-size: 13px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
            mat-menu-item
            (click)="logout()"
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
              "
            >
              <span>Logout</span>
              <em
                class="bi bi-box-arrow-left"
                style="float: right; font-size: 1rem; margin-left: 1vw"
              ></em>
            </div>
          </button>
        </mat-menu>
        <div class="dp-logo-container">
          <img
            src="../../../assets/coca_cola_india.png"
            alt="profile"
            style="height: 8vh"
          />
          <!-- <div class="subtitle">Powered By Decision Point</div> -->
        </div>
      </div>
    </div>
  </nav>
  <div *ngIf="isShow" class="button-container">
    <button (click)="handleRedirect()" class="back-btn">
      <img src="../../assets/back.svg" alt="back" />Go Back
    </button>
    <button *ngIf="!isAdmin" (click)="openUserSupportDialog()" class="support-btn">
      <img src="../../assets/support.svg" alt="support" />Support
    </button>
  </div>
</div>
